require('@rails/ujs').start();
require('@rails/activestorage').start();
require('channels');

import '../stylesheets/application.scss';

const images = require.context('../images/', true);

import './main';
import './double_submit';